import { Routes, Route } from "react-router-dom"
import ScrollToTop from "./components/utils/ScrollToTop"
import StartPage from "./pages/StartPage"
import InstantFilingPage from "./pages/InstantFilingPage"
import TrademarkPage from "./pages/TrademarkPage"
import DesignPage from "./pages/DesignPage"
import PatentPage from "./pages/PatentPage"
import AboutPage from "./pages/AboutPage"
import FaqPage from "./pages/FaqPage"
import FaqDetailPage from "./pages/FaqDetailPage"
import RegisterPage from "./pages/RegisterPage"
import LoginPage from "./pages/LoginPage"
import VerifyPage from "./pages/VerifyPage"
import OfficeActionPage from "./pages/OfficeActionPage"
import OppositionPage from "./pages/OppositionPage"
import HomePage from "./pages/HomePage"
import ProtectedRoute from "./middleware/ProtectedRoute"
import GuestRoute from "./middleware/GuestRoute"
import TrademarkFormPage from "./pages/TrademarkFormPage"
import MyApplicationsPage from "./pages/MyApplicationsPage"
import SettingsPage from "./pages/SettingsPage"
import PaymentPage from "./pages/PaymentPage"
import DesignFormPage from "./pages/DesignFormPage"
import DesignPaymentPage from "./pages/DesignPaymentPage"
import MessagesPage from "./pages/MessagesPage"
import UsersPage from "./pages/UsersPage"
import PatentFormPage from "./pages/PatentFormPage"
import PatentEpPhaseFormPage from "./pages/PatentEpPhaseFormPage"
import PatentPaymentPage from "./pages/PatentPaymentPage"

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/*Seiten für NICHT eingeloggte Nutzer*/}
      <Route
        path="/"
        element={
          <GuestRoute allowAdmin>
            <StartPage />
          </GuestRoute>
        }
      />
      <Route
        path="/register"
        element={
          <GuestRoute>
            <RegisterPage />
          </GuestRoute>
        }
      />
      <Route
        path="/login"
        element={
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        }
      />

      {/*Verify Seite ist öffentlich, damit Nutzer den Link aus der E-Mail öffnen können*/}
      <Route path="/verify" element={<VerifyPage />} />

      <Route path="/instant-filing" element={<InstantFilingPage />} />
      <Route path="/trademark" element={<TrademarkPage />} />
      <Route path="/design" element={<DesignPage />} />
      <Route path="/patent" element={<PatentPage />} />
      <Route path="/about-us" element={<AboutPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/faq/:category" element={<FaqDetailPage />} />

      {/*Für eingeloggte Nutzer*/}
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/opposition/new"
        element={
          <ProtectedRoute>
            <OppositionPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/office-action/new"
        element={
          <ProtectedRoute>
            <OfficeActionPage />
          </ProtectedRoute>
        }
      />

      {/*Neue Markenanmeldung*/}
      <Route
        path="/trademark/new"
        element={
          <ProtectedRoute>
            <TrademarkFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/designs/new"
        element={
          <ProtectedRoute>
            <DesignFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/design-applications/:id/edit"
        element={
          <ProtectedRoute>
            <DesignFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/design-applications/:id/view"
        element={
          <ProtectedRoute>
            <DesignFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/design-applications/:id/payment"
        element={
          <ProtectedRoute>
            <DesignPaymentPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/patent-applications/new"
        element={
          <ProtectedRoute>
            <PatentFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/patent-applications/ep1200/new"
        element={
          <ProtectedRoute>
            <PatentEpPhaseFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/patent-applications/:id/ep1200/edit"
        element={
          <ProtectedRoute>
            <PatentEpPhaseFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/patent-applications/:id/ep1200/view"
        element={
          <ProtectedRoute>
            <PatentEpPhaseFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/patent-applications/:id/edit"
        element={
          <ProtectedRoute>
            <PatentFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/patent-applications/:id/view"
        element={
          <ProtectedRoute>
            <PatentFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/patent-applications/:id/payment"
        element={
          <ProtectedRoute>
            <PatentPaymentPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/applications"
        element={
          <ProtectedRoute>
            <MyApplicationsPage />
          </ProtectedRoute>
        }
      />
      
      <Route 
        path="/settings" 
        element={
        <ProtectedRoute>
          <SettingsPage />
        </ProtectedRoute>
        }
      />

      <Route
        path="/messages"
        element={
          <ProtectedRoute>
            <MessagesPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/users"
        element={
          <ProtectedRoute adminOnly>
            <UsersPage />
          </ProtectedRoute>
        }
      />


       <Route
          path="/applications/:id/edit"
          element={
          <ProtectedRoute>
            <TrademarkFormPage />
          </ProtectedRoute>
        }
       />

       <Route
          path="/applications/:id/view"
          element={
          <ProtectedRoute>
            <TrademarkFormPage />
          </ProtectedRoute>
        }
       />

       <Route
          path="/applications/:id/payment"
          element={
            <ProtectedRoute>
              <PaymentPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  )
}

export default App
